import { UserDeviceEnum } from "@/__generated__/graphql";
import { copyClipboard } from "@/lib/helpers/copy-clipboard";
import { getUserDevice, handleOpenLink, share } from "@/lib/platform";

type SocialMediaPlatform = "WhatsApp" | "Telegram" | "Messenger" | "WeChat" | "SMS" | "Instagram";

const appLuceMgUrl = "https://app.luce.com/";

function useShareSocialMedia(message: string): {
  copyLinkAction(): void;
  whatsappShareAction(): void;
  telegramShareAction(): void;
  facebookMessengerShareAction(): void;
  weChatShareAction(): void;
  smsShareAction(): void;
  sharerOtherAction(): void;
  instagramShareAction(): void;
} {
  const device = getUserDevice();
  const textBasedUrl = encodeURIComponent(message);

  const handleShareAction = (platform: SocialMediaPlatform) => {
    let url = "";

    const messengerFallback = `https://www.facebook.com/sharer/sharer.php?u=${appLuceMgUrl}&t=${textBasedUrl}}`;

    switch (platform) {
      case "WhatsApp":
        url = `https://wa.me/?text=${textBasedUrl}`;
        break;
      case "Instagram":
        url = `instagram-stories://share`;
        break;
      case "Telegram":
        url = `https://t.me/share/url?url=${appLuceMgUrl}&text=${textBasedUrl}`;
        break;
      case "Messenger":
        url =
          device === UserDeviceEnum.Android
            ? "fb-messenger://"
            : `https://m.me/lucegroupsg?text=${textBasedUrl}`;
        break;
      case "SMS":
        url =
          device === UserDeviceEnum.Ios ? `sms:&body=${textBasedUrl}` : `sms:?body=${textBasedUrl}`;
        break;
      case "WeChat":
        url = `weixin://dl/chat?content=${textBasedUrl}`;
        break;
      default:
        throw new Error("Invalid platform url");
    }

    handleOpenLink(url).then((success) => {
      if (platform === "Messenger" && !success) {
        handleOpenLink(messengerFallback);
      }
    });
  };

  const copyLinkAction = (): void => {
    copyClipboard(message);
  };

  const sharerOtherAction = () => {
    share(appLuceMgUrl, message);
  };

  return {
    copyLinkAction,
    sharerOtherAction,
    whatsappShareAction: () => handleShareAction("WhatsApp"),
    telegramShareAction: () => handleShareAction("Telegram"),
    facebookMessengerShareAction: () => handleShareAction("Messenger"),
    weChatShareAction: () => handleShareAction("WeChat"),
    smsShareAction: () => handleShareAction("SMS"),
    instagramShareAction: () => handleShareAction("Instagram"),
  };
}

export default useShareSocialMedia;
